module.exports = __webpack_public_path__ + "static/media/circular-checkbox-selected-white.140d490f.svg";